module.exports = __webpack_public_path__ + "img/pay_alipay_scan.png";